import { t } from '@lingui/core/macro'

export function MaximizeButton({ onClick }) {
  return (
    <button type='button' onClick={onClick} className='maximize-button' title={t`Maximize`}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='icon icon-tabler icons-tabler-outline icon-tabler-maximize m-0'
        role='presentation'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M4 8v-2a2 2 0 0 1 2 -2h2' />
        <path d='M4 16v2a2 2 0 0 0 2 2h2' />
        <path d='M16 4h2a2 2 0 0 1 2 2v2' />
        <path d='M16 20h2a2 2 0 0 0 2 -2v-2' />
      </svg>
    </button>
  )
}
